/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Organization Form Fields
 */
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { UploadFile, Tooltip, Image } from 'antd';
import { getBase64Url } from 'utils/admin/payments';
import { getFallbackImage } from 'utils/assets';

interface ILogoUploadProps {
	value?: UploadFile;
	disabled?: boolean;
	onChange: (file: UploadFile | { url: string | null }) => void;
}

const LogoUpload: React.FC<ILogoUploadProps> = (props) => {
	const [imageUrl, setImageUrl] = useState<string | null>(null);

	useEffect(() => {
		if (props.value && typeof props.value.url === 'string') {
			setImageUrl(props.value.url);
		} else if (_.isNull(props.value?.url)) {
			setImageUrl(null);
		}
	}, [props.value]);

	return (
		<Tooltip title='Please contact our support team to upload/edit your logo'>
			<Image width={150} alt='no-logo-added' preview={!!imageUrl} src={getBase64Url(imageUrl)} fallback={getFallbackImage()} />
		</Tooltip>
	);
};

export default LogoUpload;
